//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {

    },
    data () {   
        return {
           
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/hw/hwSearch.vue